/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.personalization.rpc.SeatRequestRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const createSeatRequestRpc = {
  serviceName: 'com.hubspot.personalization.rpc.SeatRequestRpc',
  rpcName: 'createSeatRequest',
  auth: 'app',
  fingerprint: 'AEh0OGYZr9hbD_-wAjB_m5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSeatRequestsRpc = {
  serviceName: 'com.hubspot.personalization.rpc.SeatRequestRpc',
  rpcName: 'getSeatRequests',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAbhpfBl0qYYJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPendingSeatRequestsByPortalRpc = {
  serviceName: 'com.hubspot.personalization.rpc.SeatRequestRpc',
  rpcName: 'getPendingSeatRequestsByPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAbhpfBl0qYYJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cancelSeatRequestRpc = {
  serviceName: 'com.hubspot.personalization.rpc.SeatRequestRpc',
  rpcName: 'cancelSeatRequest',
  auth: 'app',
  fingerprint: 'Ww__sAIwf5viMw8jUS1z3pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const adminUpdateSeatRequestRpc = {
  serviceName: 'com.hubspot.personalization.rpc.SeatRequestRpc',
  rpcName: 'adminUpdateSeatRequest',
  auth: 'app',
  fingerprint: 'beJ_MWOQPYDiMw8jUS1z3pwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};